<template>
<div>
<div class="homeLandingLogin"></div>
<div class="row justify-content-center mt-4">
<div class="col-md-6" id="contact">
  <div class="row mt-4">
    <div class="col-md-6">
      <h1>Contact Us</h1>
      <h3 class="mt-4">Pawnee Leasing Corporation</h3>
      <p>3801 Automation Way<br>Suite 207<br>Fort Collins, CO 80525</p>
      <p><strong>PH:</strong> 1(800) 864-4266<br><strong>PH:</strong> (970) 482-2556<br><strong>Fax:</strong> (970) 224-1105</p>
      <button type="button" class="btn btn-primary"><router-link class="text-white" to="/contactform">Contact Us</router-link></button>
    </div>
    <div class="col-md-6">
      <h2>&nbsp;</h2>
      <img class="rounded mx-auto d-block img-fluid" src="/static/pawnee_contact.jpg" />
    </div>
  </div>
</div>
</div>
</div>
</template>
<script>
export default {
  name: 'Contact',
  components: {
  },
  props: {
    parentData: {
      type: Number
    }
  },
  data: function () {
    return {
      contact: {},
      message: '',
      sentClass: '',
      timer: '',
      loading: false
    }
  },
  methods: {
  }
}
</script>

<style>
#contact {
  margin: 0 auto;
  border: solid 1px #bbbbbb;
  padding:30px 40px;
  border-radius: 5px;
  background-color: #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/contact.vue